import EvaluationPage from "./page/EvaluationPage";
import BlockedPage from "./page/BlockedPage";
import { useSingleTab } from "hooks/useSingleTab";

const EvaluationBase = () => {
  const { isSingleTab } = useSingleTab("admission_tab");

  return (
    <div className="w-full h-full ">
      {isSingleTab ? <EvaluationPage /> : <BlockedPage />}
    </div>
  );
};

export default EvaluationBase;
